type ThemeColor =
  | "primary"
  | "secondary"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "light"
  | "dark";

const TAG_THEME_COLORS: { [key: string]: ThemeColor } = {
  PADRÃO: "success",
  PADRAO: "success",
  IDOSO: "warning",
  KIDS: "info",
  PCD: "dark",
  CAMINHADA: "secondary",
  ESPECIAL: "warning",
  INEXISTENTE: "error",
};

const TAG_HEX_COLORS: { [key: string]: string } = {
  PADRÃO: "#00A53C",
  PADRAO: "#00A53C",
  IDOSO: "#F9A825",
  KIDS: "#1A73E8",
  PCD: "#1A2035",
  CAMINHADA: "#4C50B7",
  ESPECIAL: "#F96030",
  INEXISTENTE: "#F93030",
};

/** Fallback legado por nome da tag (theme MUI). */
const getColorsTags = (tag: string): ThemeColor => {
  if (!tag) return "primary";
  return TAG_THEME_COLORS[tag.toUpperCase()] || "success";
};

/** Resolve a cor hex da tag (preferindo a cor salva no cadastro). */
const resolveTagColorHex = (
  tipo?: string | null,
  cor?: string | null
): string => {
  if (cor && /^#([0-9A-Fa-f]{6})$/.test(cor)) return cor;
  if (!tipo) return "#00A53C";
  return TAG_HEX_COLORS[tipo.toUpperCase()] || "#00A53C";
};

export { getColorsTags, resolveTagColorHex, TAG_HEX_COLORS };
